
import React, { useEffect, useReducer, useCallback }
    from 'react';


import stateReducer, {
    AppActions, PS_SETTINGS_SITES, PS_APPOINTMENT, PS_INITIAL,
    PS_SHOW_LOGIN, PS_BOOKING, PS_TEAM_CAL
}
    from './Reducer';

import '../../css/styles.css';


import { TwoSwitch } from '../../lib/iprs-react-library/src/index.js';

import { PageFoot, APIDebugLog, getURLSearchParam, removeURLSearchParam }
                                        from '../../lib/iprs-react-library/src/index.js';
import API                              from 'iprs-api-library';

import { LoginOverlay, AccountMenu }    from '../../lib/iprs-react-library/src/index.js';

import AltCalendar from './AltCalendar';
//import TeamEdit from '../Team/TeamEdit'
//import TemplateCalendar from '../Template/TemplateCalendar'
//import AppointmentCalendar from '../AppointmentType/AppointmentCalendar'

import SideBar from '../SideBar/SideBar';
import Popover from './Popover';

const api = new API()

const initialState = {
    pageState: PS_INITIAL,
    team: { teams: [], teamID: 0, teamName: '' },
    template: { templates: [], templateID: 0, hidden: null },
    appType: { appointmentTypes: [] },
    booking: {}
}

const debug = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

/**
 *  Validate the user's token or one that has been supplied in the URL
 */
const validateLogin = (eventDispatch) => {

    /* If the user already has a token in session storage and it is valid 
         * then we can start working. Otherwise we show the login screen*/
    api.validateLoggedIn()
        .then(r => loadDispatchLoginEvent(eventDispatch))
        .catch(r => {

            const urlToken = getURLSearchParam('token')
            if (urlToken) {

                removeURLSearchParam('token')

                /* Having failed to login with an existing token, we validate 
                 * the token and redirect to a URL without the token.
                 */
                api.validateLoggedIn(urlToken)
                    .then(r => loadDispatchLoginEvent(eventDispatch))
                    .catch(r => eventDispatch({ newState: PS_SHOW_LOGIN }))
            } else {
                eventDispatch({ newState: PS_SHOW_LOGIN })
            }
        })
}

const loadDispatchLoginEvent = (eventDispatch) => {

    /* If there is a caseID in the URL then we go on to make the booking system
     * active and it will load the case. */
    if (getURLSearchParam('caseID')) {
        eventDispatch({ newState: PS_BOOKING })
    } else {
        eventDispatch({ newState: PS_TEAM_CAL })
    }
}

function AltApp() {

    const [state, eventDispatch] = useReducer(stateReducer,
        initialState);

    state.api = api;

    /*
     * 
     */
    useEffect(() => { validateLogin(eventDispatch) }, [eventDispatch])

    const sideBar = () => {

        if (PS_INITIAL !== state.pageState) {
            return (<SideBar eventDispatch={eventDispatch} api={api}
                state={state} />)
        } else {
            return ''
        }
    }

    /**
     * Callback to say the user is loggedin or out 
     * @string actionName can be 'Logged in' or 'Logged out'
     */
    const handleLoginEvent = useCallback((actionName) => {

        const action = 'Logged in' === actionName ? AppActions.LOGGED_IN : { newState: 'show_login' };
        eventDispatch(action);
    }, []);

    return (
        <>
            <div className="App">
                <div className="container">
                    <header className="topHeader main__top">
                        <div className="main__top-logo">
                            <img src="images/iprshealth.svg" alt="IPRS Health" />
                        </div>
                        <h1 className="main__top-title">
                            IPRS Diary Management System
                        </h1>
                        <AccountMenu api={api} handleLoginEvent={handleLoginEvent} />
                    </header>
                </div>
                <TwoSwitch test={PS_SHOW_LOGIN === state.pageState} >
                    <>
                        <div className="container typography login_container" >
                            <main >
                                <LoginOverlay handleLoginEvent={handleLoginEvent} api={api} />
                            </main>
                        </div>
                        <PageFoot />
                    </>
                    <>
                        <div className="container typography main_container">

                            {sideBar()}

                            <main className="main">


                                <section className="main__section">

                                    {/*{mainContent()}*/}
                                    <Popover>
                                        <div>Popover Hello</div>
                                    </Popover>
                                    <AltCalendar api={api} state={state}
                                        eventDispatch={eventDispatch} />

                                </section>
                            </main>

                            {debug && false ? <div style={{ flex: 'auto' }}>
                                <pre style={{ maxWidth: '30em' }} >{JSON.stringify(state, null, '\t')}</pre>
                            </div> : null}
                        </div>
                        <PageFoot />
                    </>
                </TwoSwitch>


                <div className="container typography">
                    {debug ? <APIDebugLog api={api} /> : ''}
                </div>

            </div>
        </>
    )
}

export { AppActions, PS_SETTINGS_SITES, PS_APPOINTMENT };
export default AltApp;
